import { render } from "./AboutCompany.vue?vue&type=template&id=2efb567e&scoped=true"
import script from "./AboutCompany.vue?vue&type=script&lang=js"
export * from "./AboutCompany.vue?vue&type=script&lang=js"

import "./AboutCompany.vue?vue&type=style&index=0&id=2efb567e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2efb567e"]])

export default __exports__